(() => {
  const isFrench = String(window.Shopify?.locale || document.documentElement.lang || '').toLowerCase().startsWith('fr')
  const copy = isFrench
    ? {
        apply: 'Appliquer', clear: 'Effacer', retry: 'Réessayer', width: 'Largeur', depth: 'Profondeur', height: 'Hauteur',
        loading: 'Chargement des plages…', pending: 'Cliquez sur Appliquer pour mettre à jour les résultats.',
        invalid: 'Entrez deux nombres positifs. Le minimum doit être inférieur ou égal au maximum.',
        unavailable: 'Impossible de charger la plage complète. Réessayez ou utilisez les valeurs exactes.',
        tooLarge: 'Choisissez une catégorie plus précise pour utiliser une plage.',
        inches: 'po', minimum: 'Minimum', maximum: 'Maximum', anyValue: 'Toutes les valeurs', anyBtu: 'Tous les BTU',
        exactValues: 'Valeurs exactes', filter: 'Filtre', orLess: 'ou moins',
        door: ['porte', 'portes'], burner: ['brûleur', 'brûleurs'], oven: ['four', 'fours'],
        rack: ['grille', 'grilles'], basket: ['panier', 'paniers'], pot: ['cuve', 'cuves'],
      }
    : {
        apply: 'Apply', clear: 'Clear', retry: 'Retry', width: 'Width', depth: 'Depth', height: 'Height',
        loading: 'Loading ranges…', pending: 'Press Apply to update results.',
        invalid: 'Enter two positive numbers, with minimum less than or equal to maximum.',
        unavailable: 'The complete range could not load. Retry or use exact values.',
        tooLarge: 'Choose a more specific category to use a range.',
        inches: 'inches', minimum: 'Minimum', maximum: 'Maximum', anyValue: 'Any value', anyBtu: 'Any BTU',
        exactValues: 'Exact values', filter: 'Filter', orLess: 'or less',
        door: ['door', 'doors'], burner: ['burner', 'burners'], oven: ['oven', 'ovens'],
        rack: ['rack', 'racks'], basket: ['basket', 'baskets'], pot: ['pot', 'pots'],
      }
  const DIMENSION_FILTERS = {
    'filter.p.m.custom.exterior_width': {
      mode: 'range',
      label: copy.width,
      key: 'width',
      step: 0.01,
      unit: copy.inches,
    },
    'filter.p.m.custom.exterior_depth': {
      mode: 'range',
      label: copy.depth,
      key: 'depth',
      step: 0.01,
      unit: copy.inches,
    },
    'filter.p.m.custom.exterior_height': {
      mode: 'range',
      label: copy.height,
      key: 'height',
      step: 0.01,
      unit: copy.inches,
    },
  }

  const RANGE_FILTERS = {
    'filter.p.m.custom.total_btu': {
      mode: 'range',
      key: 'total_btu',
      label: 'Total BTU',
      step: 1,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
    'filter.p.m.custom.burner_btu': {
      mode: 'range',
      key: 'burner_btu',
      label: isFrench ? 'BTU du brûleur' : 'Burner BTU',
      step: 1,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
    'filter.p.m.custom.oven_btu': {
      mode: 'range',
      key: 'oven_btu',
      label: isFrench ? 'BTU du four' : 'Oven BTU',
      step: 1,
      unit: 'BTU',
      groupNumbers: true,
      useValueIndex: true,
    },
  }

  const CHIP_FILTERS = {
    'filter.p.m.custom.voltage': {
      maxValues: 12,
      unit: 'V',
      hideCounts: true,
    },
    'filter.p.m.custom.door_type': {
      maxValues: 8,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_doors': {
      maxValues: 12,
      nouns: copy.door,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_burners': {
      maxValues: 12,
      nouns: copy.burner,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_ovens': {
      maxValues: 12,
      nouns: copy.oven,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_racks': {
      maxValues: 12,
      nouns: copy.rack,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_fry_baskets': {
      maxValues: 12,
      nouns: copy.basket,
      hideCounts: true,
    },
    'filter.p.m.custom.number_of_fry_pots': {
      maxValues: 12,
      nouns: copy.pot,
      hideCounts: true,
    },
  }

  const CHIP_FILTER_LABELS = {
    'door type': CHIP_FILTERS['filter.p.m.custom.door_type'],
    'type de porte': CHIP_FILTERS['filter.p.m.custom.door_type'],
    'number of doors': CHIP_FILTERS['filter.p.m.custom.number_of_doors'],
    'number of burners': CHIP_FILTERS['filter.p.m.custom.number_of_burners'],
    'number of ovens': CHIP_FILTERS['filter.p.m.custom.number_of_ovens'],
    'number of racks': CHIP_FILTERS['filter.p.m.custom.number_of_racks'],
    'number of fry baskets': CHIP_FILTERS['filter.p.m.custom.number_of_fry_baskets'],
    'number of fry pots': CHIP_FILTERS['filter.p.m.custom.number_of_fry_pots'],
    'nombre de portes': CHIP_FILTERS['filter.p.m.custom.number_of_doors'],
    'nombre de brûleurs': CHIP_FILTERS['filter.p.m.custom.number_of_burners'],
    'nombre de fours': CHIP_FILTERS['filter.p.m.custom.number_of_ovens'],
    'nombre de grilles': CHIP_FILTERS['filter.p.m.custom.number_of_racks'],
    'nombre de paniers à friture': CHIP_FILTERS['filter.p.m.custom.number_of_fry_baskets'],
    'nombre de cuves': CHIP_FILTERS['filter.p.m.custom.number_of_fry_pots'],
  }

  const numericValue = (value) => {
    const match = String(value || '').replace(/,/g, '').match(/-?\d+(?:\.\d+)?/)
    return match ? Number(match[0]) : null
  }

  const formatNumber = (value, step = 1, groupNumbers = false) => {
    const number = Number(value)
    if (!Number.isFinite(number)) return ''

    const maximumFractionDigits = step >= 1 ? 0 : step >= 0.1 ? 1 : 2
    if (groupNumbers) {
      return new Intl.NumberFormat('en-CA', {
        minimumFractionDigits: 0,
        maximumFractionDigits,
      }).format(number)
    }

    if (maximumFractionDigits === 0) return String(Math.round(number))
    return number.toFixed(maximumFractionDigits).replace(/0+$/, '').replace(/\.$/, '')
  }

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

  const dispatchFilterChange = (form) => {
    if (form) form.dispatchEvent(new Event('change', { bubbles: true }))
  }

  const refreshAccordionHeight = (widget) => {
    const item = widget.closest('.m-accordion--item')
    const content = widget.querySelector('.m-accordion--item-content')
    if (!item || !content || !item.classList.contains('open')) return

    window.requestAnimationFrame(() => {
      item.style.setProperty('--content-max-height', `${content.scrollHeight}px`)
    })
  }

  const getNativeValues = (widget) => {
    const inputs = Array.from(widget.querySelectorAll('input[type="checkbox"]'))
    const entries = inputs
      .map((input) => ({ input, value: numericValue(input.value) }))
      .filter((entry) => entry.value !== null && (!entry.input.disabled || entry.input.checked))

    const values = [...new Set(entries.map((entry) => entry.value))].sort((a, b) => a - b)
    return { inputs, entries, values }
  }

  const NUMERIC_FILTERS = { ...DIMENSION_FILTERS, ...RANGE_FILTERS }
  const drafts = new Map()
  let catalogPromise
  let initRevision = 0
  const boundsKeys = (config) => [`cs_${config.key}_min`, `cs_${config.key}_max`]
  const parseNumber = (raw) => {
    const text = String(raw ?? '').trim().replace(/,/g, '')
    if (!/^\d+(?:\.\d+)?$/.test(text)) return null
    const value = Number(text)
    return Number.isFinite(value) && value >= 0 ? value : null
  }
  const appliedBounds = (params, param, config) => {
    if (!params.has(param)) return null
    const [minKey, maxKey] = boundsKeys(config)
    const lower = parseNumber(params.get(minKey))
    const upper = parseNumber(params.get(maxKey))
    return lower !== null && upper !== null && lower <= upper ? { lower, upper } : null
  }

  // Load an unfiltered, paginated list; facet values alone are capped at 100.
  const loadCatalog = () => {
    if (catalogPromise) return catalogPromise
    catalogPromise = (async () => {
      const source = new URL(window.location.href)
      const params = new URLSearchParams({ section_id: 'chefstop-numeric-filter-data' })
      ;['q', 'type', 'options[prefix]', 'preview_theme_id'].forEach((key) => {
        if (source.searchParams.has(key)) params.set(key, source.searchParams.get(key))
      })
      const readPage = async (page) => {
        const query = new URLSearchParams(params)
        query.set('page', String(page))
        const response = await fetch(`${source.pathname}?${query}`, { credentials: 'same-origin' })
        if (!response.ok) throw new Error('Range data request failed')
        const html = new DOMParser().parseFromString(await response.text(), 'text/html')
        const node = html.querySelector('[data-chefstop-numeric-data]')
        if (!node) throw new Error('Range data missing')
        const data = JSON.parse(node.textContent)
        if (data.page !== page || !Array.isArray(data.products) || !Number.isInteger(data.total)) {
          throw new Error('Range data incomplete')
        }
        return data
      }
      const first = await readPage(1)
      if (first.total > 25000) throw new Error('Range data too large')
      if (first.pages !== Math.ceil(first.total / 250) && first.total !== 0) {
        throw new Error('Range pagination incomplete')
      }
      const products = [...first.products]
      for (let page = 2; page <= first.pages; page += 3) {
        const pageNumbers = Array.from({ length: Math.min(3, first.pages - page + 1) }, (_, offset) => page + offset)
        const pages = await Promise.all(pageNumbers.map(readPage))
        pages.forEach((data) => {
          if (data.total !== first.total || data.pages !== first.pages) throw new Error('Range data changed')
          products.push(...data.products)
        })
      }
      if (products.length !== first.total || new Set(products.map((product) => product.id)).size !== first.total) {
        throw new Error('Range products incomplete')
      }
      const entries = {}
      Object.keys(NUMERIC_FILTERS).forEach((param) => {
        const key = param.split('.').pop()
        const values = new Map()
        products.forEach((product) => {
          const raw = String(product[key] ?? '').trim()
          const value = parseNumber(raw)
          if (value !== null) values.set(raw, { raw, value })
        })
        entries[param] = [...values.values()].sort((a, b) => a.value - b.value)
      })
      return { entries, total: first.total }
    })()
    return catalogPromise
  }

  const serializeParams = (params) => params.toString().replace(/(filter\.p\.m\.custom\.(?:exterior_width|exterior_depth|exterior_height|total_btu|burner_btu|oven_btu)=)([^&]*)/g, (_, key, values) => key + values.replace(/%2C/gi, ','))
  const renderParams = (params) => {
    params.delete('page')
    const query = serializeParams(params)
    const filtersForm = document.querySelector('collection-filters-form')
    if (filtersForm?.renderPage) filtersForm.renderPage(query)
    else window.location.assign(`${window.location.pathname}?${query}`)
  }

  const syncAppliedForm = () => {
    const form = document.getElementById('CollectionFiltersForm')
    if (!form) return
    const params = new URLSearchParams(window.location.search)
    form.querySelectorAll('[data-chefstop-range-hidden]').forEach((input) => input.remove())
    const hidden = (name, value, owner) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      input.dataset.chefstopRangeHidden = owner
      form.appendChild(input)
    }
    Object.entries(NUMERIC_FILTERS).forEach(([param, config]) => {
      if (!appliedBounds(params, param, config)) return
      hidden(param, params.getAll(param).join(','), param)
      boundsKeys(config).forEach((key) => hidden(key, params.get(key), param))
      form.querySelectorAll(`input[type="checkbox"][name="${param}"]`).forEach((input) => input.removeAttribute('name'))
    })
    ;['preview_theme_id', 'type'].forEach((key) => {
      if (params.has(key) && !form.querySelector(`[name="${key}"]`)) hidden(key, params.get(key), key)
    })
    document.querySelectorAll('.m-pagination a[href]').forEach((link) => {
      const next = new URL(link.href, window.location.href)
      Object.entries(NUMERIC_FILTERS).forEach(([param, config]) => {
        if (!next.searchParams.has(param) || !appliedBounds(params, param, config)) return
        next.searchParams.set(param, params.getAll(param).join(','))
        boundsKeys(config).forEach((key) => next.searchParams.set(key, params.get(key)))
      })
      if (params.has('preview_theme_id')) next.searchParams.set('preview_theme_id', params.get('preview_theme_id'))
      link.href = `${next.pathname}?${serializeParams(next.searchParams)}`
    })
  }

  const addNumberField = (container, options) => {
    const field = document.createElement('label')
    field.className = 'm-cf-number-field'
    const label = document.createElement('span')
    label.className = 'm-cf-number-field__label'
    label.textContent = options.label
    const input = document.createElement('input')
    input.type = 'text'
    input.inputMode = options.step >= 1 ? 'numeric' : 'decimal'
    input.className = 'form-field form-field--input'
    input.value = formatNumber(options.value, options.step, options.groupNumbers)
    input.autocomplete = 'off'
    input.setAttribute('aria-label', options.ariaLabel)
    input.addEventListener('focus', () => input.select())
    field.append(label, input)
    container.appendChild(field)
    return input
  }

  const updateRangeTrack = (container, lower, upper, min, max) => {
    const span = max - min || 1
    container.style.setProperty('--range-start', `${clamp(((lower - min) / span) * 100, 0, 100)}%`)
    container.style.setProperty('--range-end', `${clamp(((upper - min) / span) * 100, 0, 100)}%`)
  }

  const enhanceNumericWidget = (widget, config, catalog, loadError) => {
    if (widget.dataset.chefstopFilterUxReady === 'true') return
    const content = widget.querySelector('.m-filter--widget-content')
    const list = content?.querySelector('ul.m-facets')
    if (!content || !list) return
    const param = widget.dataset.filterParam
    const { values: nativeValues } = getNativeValues(widget)
    const entries = catalog?.entries[param] || []
    const values = [...new Set(entries.map((entry) => entry.value))].sort((a, b) => a - b)
    const domain = values.length ? values : nativeValues
    if (!domain.length) return
    if (!values.length && !loadError) loadError = new Error('Range data missing for this filter')
    const min = domain[0]
    const max = domain[domain.length - 1]
    const form = widget.closest('form')
    const params = new URLSearchParams(window.location.search)
    const applied = appliedBounds(params, param, config)
    const selected = params.getAll(param).flatMap((value) => value.split(',')).map(parseNumber).filter((value) => value !== null)
    const initialLower = applied?.lower ?? (selected.length ? Math.min(...selected) : min)
    const initialUpper = applied?.upper ?? (selected.length ? Math.max(...selected) : max)
    const control = document.createElement('div')
    control.className = 'm-cf-control m-cf-control--range'
    control.dataset.chefstopControl = 'true'
    control.dataset.rangeValueCount = String(values.length)
    control.dataset.rangeProductCount = String(catalog?.total || 0)
    const heading = document.createElement('div')
    heading.className = 'm-cf-control__heading'
    heading.textContent = widget.dataset.filterLabel || config.label
    const unit = document.createElement('span')
    unit.className = 'm-cf-control__unit'
    unit.textContent = config.unit
    heading.appendChild(unit)
    const sliders = document.createElement('div')
    sliders.className = 'm-cf-control__sliders m-cf-control__sliders--range'
    const choices = document.createElement('div')
    choices.className = 'm-cf-control__choices'
    choices.setAttribute('role', 'group')
    choices.setAttribute('aria-label', widget.dataset.filterLabel || config.label)
    const choiceButtons = []
    const fields = document.createElement('div')
    fields.className = 'm-cf-control__fields'
    const actions = document.createElement('div')
    actions.className = 'm-cf-control__actions'
    const apply = document.createElement('button')
    apply.type = 'button'
    apply.className = 'm-cf-control__apply'
    apply.textContent = copy.apply
    apply.setAttribute('aria-label', `${copy.apply} ${widget.dataset.filterLabel || config.label}`)
    const clear = document.createElement('button')
    clear.type = 'button'
    clear.className = 'm-cf-control__clear'
    clear.textContent = copy.clear
    clear.setAttribute('aria-label', `${copy.clear} ${widget.dataset.filterLabel || config.label}`)
    actions.append(apply, clear)
    const status = document.createElement('p')
    status.className = 'm-cf-control__status'
    status.id = `chefstop-range-status-${config.key}`
    status.setAttribute('role', 'status')
    status.setAttribute('aria-live', 'polite')
    const minInput = addNumberField(fields, { label: copy.minimum, value: initialLower, step: config.step, groupNumbers: config.groupNumbers, ariaLabel: `${widget.dataset.filterLabel || config.label} minimum` })
    const maxInput = addNumberField(fields, { label: copy.maximum, value: initialUpper, step: config.step, groupNumbers: config.groupNumbers, ariaLabel: `${widget.dataset.filterLabel || config.label} maximum` })
    ;[minInput, maxInput].forEach((input) => input.setAttribute('aria-describedby', status.id))
    const draft = drafts.get(param)
    if (draft) [minInput.value, maxInput.value] = draft
    const indexForValue = (value) => domain.reduce((best, candidate, index) => Math.abs(candidate - value) < Math.abs(domain[best] - value) ? index : best, 0)
    const position = (value) => config.useValueIndex ? indexForValue(value) : clamp(value, min, max)
    const makeSlider = (value, bound) => {
      const slider = document.createElement('input')
      slider.type = 'range'
      slider.className = `m-cf-control__slider m-cf-control__slider--${bound}`
      slider.min = config.useValueIndex ? '0' : String(min)
      slider.max = config.useValueIndex ? String(domain.length - 1) : String(max)
      slider.step = config.useValueIndex ? '1' : String(config.step)
      slider.value = String(position(value))
      slider.disabled = domain.length < 2 || Boolean(loadError)
      slider.setAttribute('aria-label', `${widget.dataset.filterLabel || config.label} ${bound === 'min' ? 'minimum' : 'maximum'} slider`)
      return slider
    }
    const minSlider = makeSlider(initialLower, 'min')
    const maxSlider = makeSlider(initialUpper, 'max')
    sliders.append(minSlider, maxSlider)
    const readBounds = () => {
      const lower = minInput.value.trim() === '' ? min : parseNumber(minInput.value)
      const upper = maxInput.value.trim() === '' ? max : parseNumber(maxInput.value)
      const precision = config.step === 1 ? 1 : 100
      const validPrecision = (value) => value !== null && Math.abs(value * precision - Math.round(value * precision)) < 0.000001
      return validPrecision(lower) && validPrecision(upper) && lower <= upper ? { lower, upper } : null
    }
    const refresh = () => {
      const bounds = readBounds()
      const dirty = minInput.value !== formatNumber(initialLower, config.step, config.groupNumbers) || maxInput.value !== formatNumber(initialUpper, config.step, config.groupNumbers)
      apply.disabled = Boolean(loadError) || !bounds || !dirty
      clear.disabled = !params.has(param) && !dirty
      status.textContent = loadError ? (loadError.message === 'Range data too large' ? copy.tooLarge : copy.unavailable) : !bounds ? copy.invalid : dirty ? copy.pending : ''
      status.classList.toggle('is-error', Boolean(loadError) || !bounds)
      ;[minInput, maxInput].forEach((input) => input.setAttribute('aria-invalid', String(!bounds)))
      if (bounds) {
        minSlider.value = String(position(bounds.lower))
        maxSlider.value = String(position(bounds.upper))
        minSlider.setAttribute('aria-valuetext', `${formatNumber(bounds.lower, config.step, config.groupNumbers)} ${config.unit}`)
        maxSlider.setAttribute('aria-valuetext', `${formatNumber(bounds.upper, config.step, config.groupNumbers)} ${config.unit}`)
        updateRangeTrack(sliders, Number(minSlider.value), Number(maxSlider.value), Number(minSlider.min), Number(maxSlider.max))
        // At the upper endpoint, expose the minimum thumb so it can move away again.
        minSlider.style.zIndex = minSlider.value === maxSlider.value && Number(maxSlider.value) === Number(maxSlider.max) ? '4' : '2'
      }
      choiceButtons.forEach(({ button, lower, upper }) => {
        const active = bounds && (lower === min && upper === max
          ? bounds.lower <= min && bounds.upper >= max
          : bounds.lower === lower && bounds.upper === upper)
        button.setAttribute('aria-pressed', String(Boolean(active)))
      })
      refreshAccordionHeight(widget)
    }
    const saveDraft = () => {
      drafts.set(param, [minInput.value, maxInput.value])
      refresh()
    }
    if (domain.length === 2 && !loadError) {
      const addChoice = (label, lower, upper) => {
        const button = document.createElement('button')
        button.type = 'button'
        button.className = 'm-cf-control__choice'
        button.textContent = label
        button.setAttribute('aria-label', `${widget.dataset.filterLabel || config.label}: ${label}`)
        button.addEventListener('click', () => {
          minInput.value = formatNumber(lower, config.step, config.groupNumbers)
          maxInput.value = formatNumber(upper, config.step, config.groupNumbers)
          saveDraft()
        })
        choiceButtons.push({ button, lower, upper })
        choices.appendChild(button)
      }
      addChoice(config.unit === 'BTU' ? copy.anyBtu : copy.anyValue, min, max)
      domain.forEach((value) => addChoice(`${formatNumber(value, config.step, config.groupNumbers)} ${config.unit}`, value, value))
    }
    const submit = (remove = false) => {
      const bounds = readBounds()
      if (!remove && (loadError || !bounds)) return
      const next = new URLSearchParams(new FormData(form))
      next.delete(param)
      boundsKeys(config).forEach((key) => next.delete(key))
      if (!remove && !(bounds.lower <= min && bounds.upper >= max)) {
        const matches = entries.filter(({ value }) => value >= bounds.lower - 0.000001 && value <= bounds.upper + 0.000001).map(({ raw }) => raw)
        // An unmatched numeric value produces zero results; clearing would show everything.
        next.set(param, matches.length ? matches.join(',') : String(bounds.lower))
        const [minKey, maxKey] = boundsKeys(config)
        next.set(minKey, String(bounds.lower))
        next.set(maxKey, String(bounds.upper))
      }
      drafts.delete(param)
      renderParams(next)
    }
    ;[minInput, maxInput].forEach((input) => {
      input.addEventListener('input', saveDraft)
      input.addEventListener('change', saveDraft)
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          event.stopPropagation()
          if (!apply.disabled) submit()
        }
      })
    })
    ;[[minSlider, minInput, maxSlider, true], [maxSlider, maxInput, minSlider, false]].forEach(([slider, input, other, isMin]) => {
      slider.addEventListener('input', () => {
        if (isMin ? Number(slider.value) > Number(other.value) : Number(slider.value) < Number(other.value)) slider.value = other.value
        const value = config.useValueIndex ? domain[Number(slider.value)] : Number(slider.value)
        input.value = formatNumber(value, config.step, config.groupNumbers)
        saveDraft()
      })
    })
    // The theme submits on every bubbled change. Draft controls must stay local.
    control.addEventListener('change', (event) => event.stopPropagation())
    control.addEventListener('input', (event) => event.stopPropagation())
    apply.addEventListener('click', () => submit())
    clear.addEventListener('click', () => submit(true))
    control.appendChild(heading)
    if (choiceButtons.length) control.appendChild(choices)
    if (domain.length > 2 || loadError) control.appendChild(sliders)
    control.append(fields, actions, status)
    if (loadError && loadError.message !== 'Range data too large') {
      const retry = document.createElement('button')
      retry.type = 'button'
      retry.className = 'm-cf-control__clear'
      retry.textContent = copy.retry
      retry.addEventListener('click', () => {
        catalogPromise = null
        document.querySelectorAll('.m-cf-control, .m-cf-range-loading').forEach((node) => node.remove())
        document.querySelectorAll('[data-chefstop-filter-ux-ready]').forEach((node) => delete node.dataset.chefstopFilterUxReady)
        init()
      })
      control.appendChild(retry)
    }
    content.insertBefore(control, list.closest('details') || list)
    if (!list.closest('.m-cf-exact-values')) {
      const exact = document.createElement('details')
      exact.className = 'm-cf-exact-values'
      const summary = document.createElement('summary')
      summary.textContent = copy.exactValues
      exact.appendChild(summary)
      content.insertBefore(exact, list)
      exact.appendChild(list)
      exact.addEventListener('toggle', () => refreshAccordionHeight(widget))
    }
    list.closest('.m-cf-exact-values').hidden = !loadError
    if (!list.dataset.chefstopExactBound) {
      list.dataset.chefstopExactBound = 'true'
      list.addEventListener('change', () => {
        drafts.delete(param)
        form.querySelectorAll('[data-chefstop-range-hidden]').forEach((input) => {
          if (input.dataset.chefstopRangeHidden === param) input.remove()
        })
        widget.querySelectorAll('input[type="checkbox"]').forEach((input) => input.name = param)
      })
    }
    widget.dataset.chefstopFilterUxReady = 'true'
    widget.classList.add('m-cf-enhanced')
    refresh()
  }

  const enhanceChipWidget = (widget, config) => {
    if (widget.dataset.chefstopChipUxReady === 'true') return

    const list = widget.querySelector('ul.m-facets')
    if (!list) return

    const items = Array.from(list.querySelectorAll(':scope > li.m-facet--item'))
    if (items.length < 1 || items.length > config.maxValues) return

    list.classList.add('m-cf-chip-list')
    if (config.hideCounts) list.classList.add('m-cf-chip-list--hide-counts')
    items.forEach((item) => {
      const input = item.querySelector('input[type="checkbox"]')
      const label = item.querySelector('.m-facet--label')
      if (!input || !label) return

      const value = label.textContent.trim()
      const number = numericValue(value)
      if (config.nouns && number !== null) {
        label.textContent = `${value} ${number === 1 ? config.nouns[0] : config.nouns[1]}`
      } else if (config.unit && value && !value.toLowerCase().endsWith(config.unit.toLowerCase())) {
        label.textContent = `${value}${config.unit}`
      }

      const syncSelectedClass = () => item.classList.toggle('is-selected', input.checked)
      syncSelectedClass()
      input.addEventListener('change', syncSelectedClass)
    })

    widget.dataset.chefstopChipUxReady = 'true'
    widget.classList.add('m-cf-chip-widget')
    refreshAccordionHeight(widget)
  }

  const initActiveSummaries = () => {
    const params = new URLSearchParams(window.location.search)
    const active = document.getElementById('ActiveFacets')
    document.querySelectorAll('[data-chefstop-summary-label]').forEach((label) => {
      const param = label.closest('[data-chefstop-remove-param]')?.dataset.chefstopRemoveParam
      const config = NUMERIC_FILTERS[param]
      const bounds = config && appliedBounds(params, param, config)
      const lower = bounds?.lower ?? numericValue(label.dataset.summaryMin)
      const upper = bounds?.upper ?? numericValue(label.dataset.summaryMax)
      if (lower === null || upper === null) return
      const name = label.dataset.summaryName || config?.label || copy.filter
      const unit = config?.unit || label.dataset.summaryUnit || ''
      label.textContent = `${name}: ${formatNumber(lower, config?.step || 0.01, true)}\u2013${formatNumber(upper, config?.step || 0.01, true)} ${unit}`
    })
    if (!active) return
    Object.entries(NUMERIC_FILTERS).forEach(([param, config]) => {
      const bounds = appliedBounds(params, param, config)
      if (!bounds || active.querySelector(`[data-chefstop-remove-param="${param}"]`)) return
      const chip = document.createElement('div')
      chip.className = 'm-active-facets--item m-cf-active-summary'
      const link = document.createElement('a')
      const removeURL = new URL(window.location.href)
      removeURL.searchParams.delete(param)
      boundsKeys(config).forEach((key) => removeURL.searchParams.delete(key))
      link.href = `${removeURL.pathname}${removeURL.search}`
      link.dataset.chefstopRemoveParam = param
      link.setAttribute('aria-label', `${copy.clear} ${config.label}`)
      link.textContent = `${config.label}: ${formatNumber(bounds.lower, config.step, true)}\u2013${formatNumber(bounds.upper, config.step, true)} ${config.unit}`
      const icon = document.createElement('span')
      icon.className = 'm-active-facets--remove-icon'
      icon.setAttribute('aria-hidden', 'true')
      icon.textContent = '\u00d7'
      link.appendChild(icon)
      chip.appendChild(link)
      active.prepend(chip)
    })
    if (active.querySelector('.m-cf-active-summary') && !active.querySelector('.m-active-facets--remove-all')) {
      const clearAll = document.createElement('div')
      clearAll.className = 'm-active-facets--item m-active-facets--item-remove-all'
      const link = document.createElement('a')
      const clearURL = new URL(window.location.href)
      Array.from(clearURL.searchParams.keys()).forEach((key) => {
        if (key.startsWith('filter.') || key.startsWith('cs_') || key === 'page') clearURL.searchParams.delete(key)
      })
      link.href = `${clearURL.pathname}${clearURL.search}`
      link.className = 'm-active-facets--remove-all'
      link.dataset.chefstopClearAll = 'true'
      link.textContent = isFrench ? 'Tout effacer' : 'Clear all'
      clearAll.appendChild(link)
      active.appendChild(clearAll)
    }
  }

  const bindSummaryRemoval = () => {
    if (window.chefstopFilterSummaryRemovalBound) return
    window.chefstopFilterSummaryRemovalBound = true
    document.addEventListener('click', (event) => {
      const link = event.target.closest('facet-remove a, [data-chefstop-remove-param], [data-chefstop-clear-all]')
      if (!link) return
      const current = new URL(window.location.href)
      const param = link.dataset.chefstopRemoveParam
      const next = param ? new URLSearchParams(current.searchParams) : new URL(link.href, current).searchParams
      if (param) {
        next.delete(param)
        const config = NUMERIC_FILTERS[param]
        if (config) boundsKeys(config).forEach((key) => next.delete(key))
        drafts.delete(param)
      } else {
        Object.entries(NUMERIC_FILTERS).forEach(([key, config]) => {
          // Native removal links can omit our URL metadata and capped values.
          if (next.has(key) && appliedBounds(current.searchParams, key, config)) {
            next.set(key, current.searchParams.getAll(key).join(','))
            boundsKeys(config).forEach((bound) => next.set(bound, current.searchParams.get(bound)))
          } else {
            boundsKeys(config).forEach((bound) => next.delete(bound))
            drafts.delete(key)
          }
        })
      }
      if (current.searchParams.has('preview_theme_id')) next.set('preview_theme_id', current.searchParams.get('preview_theme_id'))
      event.preventDefault()
      event.stopImmediatePropagation()
      renderParams(next)
    }, true)
  }

  const init = async () => {
    const revision = ++initRevision
    // Preview/share tools may encode the list delimiters. Restore Shopify's
    // accepted format before displaying their initially unmatched results.
    if (/(filter\.p\.m\.custom\.(?:exterior_width|exterior_depth|exterior_height|total_btu|burner_btu|oven_btu)=)[^&]*%2C/i.test(window.location.search)) {
      const query = serializeParams(new URLSearchParams(window.location.search))
      const filtersForm = document.querySelector('collection-filters-form')
      if (filtersForm?.renderPage) {
        history.replaceState({ searchParams: query }, '', `${window.location.pathname}?${query}`)
        filtersForm.renderPage(query, false)
      } else {
        window.location.replace(`${window.location.pathname}?${query}`)
      }
      return
    }
    syncAppliedForm()
    initActiveSummaries()
    bindSummaryRemoval()
    const widgets = Array.from(document.querySelectorAll('.facest-filters-section .m-filter--widget[data-filter-param]'))
    widgets.forEach((widget) => {
      const labelKey = String(widget.dataset.filterLabel || '').trim().toLowerCase()
      const chipConfig = CHIP_FILTERS[widget.dataset.filterParam] || CHIP_FILTER_LABELS[labelKey]
      if (chipConfig) enhanceChipWidget(widget, chipConfig)
      if (NUMERIC_FILTERS[widget.dataset.filterParam] && !widget.querySelector('.m-cf-control, .m-cf-range-loading')) {
        const loading = document.createElement('p')
        loading.className = 'm-cf-range-loading'
        loading.textContent = copy.loading
        widget.querySelector('.m-filter--widget-content')?.prepend(loading)
        refreshAccordionHeight(widget)
      }
    })
    if (!widgets.some((widget) => NUMERIC_FILTERS[widget.dataset.filterParam])) return
    let catalog
    let loadError
    try { catalog = await loadCatalog() } catch (error) { loadError = error }
    if (revision !== initRevision) return
    syncAppliedForm()
    document.querySelectorAll('.m-cf-range-loading').forEach((node) => node.remove())
    document.querySelectorAll('.facest-filters-section .m-filter--widget[data-filter-param]').forEach((widget) => {
      const config = NUMERIC_FILTERS[widget.dataset.filterParam]
      if (config) enhanceNumericWidget(widget, config, catalog, loadError)
    })
  }

  window.addEventListener('popstate', () => drafts.clear())
  document.addEventListener('collection:rerendered', () => window.requestAnimationFrame(init))
  document.addEventListener('DOMContentLoaded', init)
  if (document.readyState !== 'loading') window.requestAnimationFrame(init)
})()
